// extracted by mini-css-extract-plugin
export default {"our_team_section_wrapper":"OurTeam_our_team_section_wrapper__5stjG","section_header":"OurTeam_section_header__26v2m","our_team_row_wrapper":"OurTeam_our_team_row_wrapper__XCadl"};